import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IRecordExpiredFurtherEducationListItem, RecordExpiredFurtherEducationListItem } from "./recordExpiredFurtherEducationListItem";

export interface IRecordExpiredFurtherEducationListItems extends ListItems<IRecordExpiredFurtherEducationListItem> { }

export class RecordExpiredFurtherEducationListItems extends ListItems<RecordExpiredFurtherEducationListItem> implements IRecordExpiredFurtherEducationListItems {
    constructor();
    constructor(obj: IRecordExpiredFurtherEducationListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordExpiredFurtherEducationListItem);
    }
}